import React from "react";
import { Nav, NavLink } from "react-bootstrap";
import { Link } from "react-router-dom";

import "./navbar.css";

function NavBar() {

  return (
    <div className='nav-container d-flex'>
      <Nav className="m-auto d-inline-flex justify-content-around flex-wrap gap-2 ">

          <NavLink eventKey="1" as={Link} to="/" className="navlink " >
            HEM
          </NavLink>

          <NavLink
            eventKey="2"
            as={Link}
            to="/services"
            className="navlink"
          >
            TJÄNSTER
          </NavLink>

          <NavLink
            eventKey="4"
            as={Link}
            to="/about"
            className="navlink"
          >
            OM OSS
          </NavLink>
          <NavLink
            eventKey="5"
            as={Link}
            to="/contact"
            className="navlink"
          >
            KONTAKTA OSS
          </NavLink>
      </Nav>
    </div>
  );
}

export default NavBar;
